import { defineComponent as m, watchEffect as _, h as a } from "vue";
import h from "./ghl-ui.es1343.js";
import { useDualCalendarProps as k, useDualCalendar as y } from "./ghl-ui.es1344.js";
import { warnOnce as D } from "./ghl-ui.es853.js";
import { resolveSlot as d } from "./ghl-ui.es860.js";
import u from "./ghl-ui.es1069.js";
import v from "./ghl-ui.es1067.js";
import f from "./ghl-ui.es1066.js";
import $ from "./ghl-ui.es1068.js";
import C, { XButton as x } from "./ghl-ui.es253.js";
import g from "./ghl-ui.es1147.js";
const N = m({
  name: "DateRangePanel",
  props: k,
  setup(r) {
    return process.env.NODE_ENV !== "production" && _(() => {
      var s;
      !((s = r.actions) === null || s === void 0) && s.includes("now") && D("date-picker", "The `now` action is not supported for n-date-picker of `daterange` type");
    }), y(r, "daterange");
  },
  render() {
    var r, s, c;
    const {
      mergedClsPrefix: e,
      mergedTheme: i,
      shortcuts: o,
      onRender: p,
      $slots: n
    } = this;
    return p == null || p(), a("div", {
      ref: "selfRef",
      tabindex: 0,
      class: [`${e}-date-panel`, `${e}-date-panel--daterange`, !this.panel && `${e}-date-panel--shadow`, this.themeClass],
      onKeydown: this.handlePanelKeyDown,
      onFocus: this.handlePanelFocus
    }, a("div", {
      ref: "startDatesElRef",
      class: `${e}-date-panel-calendar ${e}-date-panel-calendar--start`
    }, a("div", {
      class: `${e}-date-panel-month`
    }, a("div", {
      class: `${e}-date-panel-month__fast-prev`,
      onClick: this.startCalendarPrevYear
    }, d(n["prev-year"], () => [a(u, null)])), a("div", {
      class: `${e}-date-panel-month__prev`,
      onClick: this.startCalendarPrevMonth
    }, d(n["prev-month"], () => [a(v, null)])), a(h, {
      monthBeforeYear: this.locale.monthBeforeYear,
      value: this.startCalendarDateTime,
      onUpdateValue: this.onUpdateStartCalendarValue,
      mergedClsPrefix: e,
      calendarMonth: this.startCalendarMonth,
      calendarYear: this.startCalendarYear
    }), a("div", {
      class: `${e}-date-panel-month__next`,
      onClick: this.startCalendarNextMonth
    }, d(n["next-month"], () => [a(f, null)])), a("div", {
      class: `${e}-date-panel-month__fast-next`,
      onClick: this.startCalendarNextYear
    }, d(n["next-year"], () => [a($, null)]))), a("div", {
      class: `${e}-date-panel-weekdays`
    }, this.weekdays.map((t) => a("div", {
      key: t,
      class: `${e}-date-panel-weekdays__day`
    }, t))), a("div", {
      class: `${e}-date-panel__divider`
    }), a("div", {
      class: `${e}-date-panel-dates`
    }, this.startDateArray.map((t, l) => a("div", {
      "data-n-date": !0,
      key: l,
      class: [`${e}-date-panel-date`, {
        [`${e}-date-panel-date--excluded`]: !t.inCurrentMonth,
        [`${e}-date-panel-date--current`]: t.isCurrentDate,
        [`${e}-date-panel-date--selected`]: t.selected,
        [`${e}-date-panel-date--covered`]: t.inSpan,
        [`${e}-date-panel-date--start`]: t.startOfSpan,
        [`${e}-date-panel-date--end`]: t.endOfSpan,
        [`${e}-date-panel-date--disabled`]: this.mergedIsDateDisabled(t.ts)
      }],
      onClick: () => {
        this.handleDateClick(t);
      },
      onMouseenter: () => {
        this.handleDateMouseEnter(t);
      }
    }, a("div", {
      class: `${e}-date-panel-date__trigger`
    }), t.dateObject.date, t.isCurrentDate ? a("div", {
      class: `${e}-date-panel-date__sup`
    }) : null)))), a("div", {
      class: `${e}-date-panel__vertical-divider`
    }), a("div", {
      ref: "endDatesElRef",
      class: `${e}-date-panel-calendar ${e}-date-panel-calendar--end`
    }, a("div", {
      class: `${e}-date-panel-month`
    }, a("div", {
      class: `${e}-date-panel-month__fast-prev`,
      onClick: this.endCalendarPrevYear
    }, d(n["prev-year"], () => [a(u, null)])), a("div", {
      class: `${e}-date-panel-month__prev`,
      onClick: this.endCalendarPrevMonth
    }, d(n["prev-month"], () => [a(v, null)])), a(h, {
      monthBeforeYear: this.locale.monthBeforeYear,
      value: this.endCalendarDateTime,
      onUpdateValue: this.onUpdateEndCalendarValue,
      mergedClsPrefix: e,
      calendarMonth: this.endCalendarMonth,
      calendarYear: this.endCalendarYear
    }), a("div", {
      class: `${e}-date-panel-month__next`,
      onClick: this.endCalendarNextMonth
    }, d(n["next-month"], () => [a(f, null)])), a("div", {
      class: `${e}-date-panel-month__fast-next`,
      onClick: this.endCalendarNextYear
    }, d(n["next-year"], () => [a($, null)]))), a("div", {
      class: `${e}-date-panel-weekdays`
    }, this.weekdays.map((t) => a("div", {
      key: t,
      class: `${e}-date-panel-weekdays__day`
    }, t))), a("div", {
      class: `${e}-date-panel__divider`
    }), a("div", {
      class: `${e}-date-panel-dates`
    }, this.endDateArray.map((t, l) => a("div", {
      "data-n-date": !0,
      key: l,
      class: [`${e}-date-panel-date`, {
        [`${e}-date-panel-date--excluded`]: !t.inCurrentMonth,
        [`${e}-date-panel-date--current`]: t.isCurrentDate,
        [`${e}-date-panel-date--selected`]: t.selected,
        [`${e}-date-panel-date--covered`]: t.inSpan,
        [`${e}-date-panel-date--start`]: t.startOfSpan,
        [`${e}-date-panel-date--end`]: t.endOfSpan,
        [`${e}-date-panel-date--disabled`]: this.mergedIsDateDisabled(t.ts)
      }],
      onClick: () => {
        this.handleDateClick(t);
      },
      onMouseenter: () => {
        this.handleDateMouseEnter(t);
      }
    }, a("div", {
      class: `${e}-date-panel-date__trigger`
    }), t.dateObject.date, t.isCurrentDate ? a("div", {
      class: `${e}-date-panel-date__sup`
    }) : null)))), this.datePickerSlots.footer ? a("div", {
      class: `${e}-date-panel-footer`
    }, this.datePickerSlots.footer()) : null, !((r = this.actions) === null || r === void 0) && r.length || o ? a("div", {
      class: `${e}-date-panel-actions`
    }, a("div", {
      class: `${e}-date-panel-actions__prefix`
    }, o && Object.keys(o).map((t) => {
      const l = o[t];
      return Array.isArray(l) || typeof l == "function" ? a(x, {
        size: "tiny",
        onMouseenter: () => {
          this.handleRangeShortcutMouseenter(l);
        },
        onClick: () => {
          this.handleRangeShortcutClick(l);
        },
        onMouseleave: () => {
          this.handleShortcutMouseleave();
        }
      }, {
        default: () => t
      }) : null;
    })), a("div", {
      class: `${e}-date-panel-actions__suffix`
    }, !((s = this.actions) === null || s === void 0) && s.includes("clear") ? a(C, {
      theme: i.peers.Button,
      themeOverrides: i.peerOverrides.Button,
      size: "tiny",
      onClick: this.handleClearClick
    }, {
      default: () => this.locale.clear
    }) : null, !((c = this.actions) === null || c === void 0) && c.includes("confirm") ? a(C, {
      theme: i.peers.Button,
      themeOverrides: i.peerOverrides.Button,
      size: "tiny",
      type: "primary",
      disabled: this.isRangeInvalid || this.isSelecting,
      onClick: this.handleConfirmClick
    }, {
      default: () => this.locale.confirm
    }) : null)) : null, a(g, {
      onFocus: this.handleFocusDetectorFocus
    }));
  }
});
export {
  N as default
};
